import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector     : 'fuse-confirmation-dialog',
    templateUrl  : './dialog.component.html',
    styles       : [
        /* language=SCSS */
        `
            .fuse-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-dialog-container {
                    padding: 0 !important;
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None
})
export class FuseConfirmationDialogComponent implements OnInit
{
    data: FuseConfirmationConfig;

    /**
     * Constructor
     */
    constructor(
        public dialogRef: DynamicDialogRef<FuseConfirmationDialogComponent>,
        public dialogConfig: DynamicDialogConfig<FuseConfirmationConfig>
    )
    {
        this.data = dialogConfig.data;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

}
